export const USER_TYPE = {
  GESTOR: 'Gestor',
  TELCO: 'Telco',
}
